$(document).ready(function() {
    $("#formService").submit(function(event) {
        
        event.preventDefault();
        $('.is-invalid').removeClass('is-invalid');
        $('.invalid-feedback').empty();

        function IsEmail(email) {
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return regex.test(email);
        }

        function IsVin(vin) {
            var regex = /^[A-HJ-NPR-Z0-9]{17}$/;
            return regex.test(vin);
        }


        function IsTel(tel) {
            var regex = /^[0-9]{9}$/;
            return regex.test(tel);
        }

        let errors = 0;

        let review = $("#formServiceReview");
        let tires = $("#formServiceTires");
        let service = $("#formServiceService");

        const width = $(window).width();

        if (!review.is(":checked") && !tires.is(":checked") && !service.is(":checked")) {
            review.addClass('is-invalid');
            tires.addClass('is-invalid');
            service.addClass('is-invalid');
            if (width > 991) {
                $(".invalid-feedback-review").html("<p>Proszę wybrać min. 1 z 3 celów wizyty</p>");
            } else {
                $(".invalid-feedback-service").html("<p>Proszę wybrać min. 1 z 3 celów wizyty</p>");
            }

            errors = 1;
        } else {
            review.removeClass('is-invalid');
            tires.removeClass('is-invalid');
            service.removeClass('is-invalid');
        }

        var reviewVal = 0;
        var tiresVal = 0;
        var serviceVal = 0;

        if (review) {
            reviewVal = 1;
        }
        if (tires) {
            tiresVal = 1;
        }
        if (service) {
            serviceVal = 1;
        }

        let firstnameInputValue = $("#formServiceFirstname").val();
        let firstname = $("#formServiceFirstname");
        if (!firstname.val()) {
            firstname.addClass('is-invalid');
            $(".feedback_firstname").html("<p>Imię jest wymagane!</p>");
            errors = 1;
        } else {
            firstname.removeClass('is-invalid');
        }


        let lastnameInputValue = $("#formServiceLastname").val();
        let lastname = $("#formServiceLastname");
        if (!lastname.val()) {
            lastname.addClass('is-invalid');
            $(".feedback_lastname").html("<p>Nazwisko jest wymagane!</p>");
            errors = 1;
        } else {
            lastname.removeClass('is-invalid');
        }


        let emailInputValue = $("#formServiceEmail").val();
        let email = $("#formServiceEmail");
        if (email.val()) {
            if (!IsEmail(email.val())) {
                email.addClass('is-invalid');
                errors = 1;
                $(".feedback_email").html("<p>Niepoprawny format email!</p>");
            } else {
                email.removeClass('is-invalid');

            }
        } else {
            email.addClass('is-invalid');
            $(".feedback_email").html("<p>Email jest wymagany!</p>");
            errors = 1;
        }

        let phoneInputValue = $("#formServicePhone").val();
        let phone = $("#formServicePhone");
        if (phoneInputValue) {
            if (phoneInputValue.length < 7) {
                phone.addClass('is-invalid');
                $(".feedback_tel").html("<p>Podany numer telefonu jest za krótki</p>");
                errors = 1;
            } else {
                if (!IsTel(phoneInputValue)) {
                    phone.addClass('is-invalid');
                    $(".feedback_tel").html('<p>Wpisz poprawny 9-cyfrowy numer telefonu</p>');
                    errors = 1;
                } else {
                    phone.removeClass('is-invalid');
                }
            }
        }

        let dataInputValue = $("#formServiceDate").val();
        let data = $("#formServiceDate");
        if (!data.val()) {
            data.addClass('is-invalid');
            $(".feedback_date").html("<p>Preferowana data wizyty jest wymagana!</p>");
            errors = 1;
        } else {
            data.removeClass('is-invalid');
        }


        let timeInputValue = $("#formServiceTime").val();
        let time = $("#formServiceTime");
        if (!time.val()) {
            time.addClass('is-invalid');
            $(".feedback_time").html("<p>Preferowana godzina wizyty jest wymagana!</p>");
            errors = 1;
        } else {
            time.removeClass('is-invalid');
        }

        let vin = $("#formServiceVin");
        let vinInputValue = $("#formServiceVin").val();
        if (!vinInputValue) {
            $(".feedback_vin").html("<p>Proszę podać VIN!</p>");
            vin.addClass('is-invalid');
            errors = 1;
        } else if (!IsVin(vinInputValue)) {
            $(".feedback_vin").html('<p>Niepoprawny format VIN!</p>');
            vin.addClass('is-invalid');
            errors = 1;
        } else {
            vin.removeClass('is-invalid');
        }

        var agree1 = $('#formServiceAgreeRegulations1').prop('checked');
        var agree2 = $('#formServiceAgreeRegulations2').prop('checked');

        if (!agree1) {
            $('#formServiceAgreeRegulations1').addClass('is-invalid');
            $('.feedback_agree_regulations1').html('<p>To pole jest wymagane</p>');
            errors = 1;
        } else {
            $('#formServiceAgreeRegulations1').removeClass('is-invalid');
            $('.feedback_agree_regulations1').empty();

        }

        if (!agree2) {
            $('#formServiceAgreeRegulations2').addClass('is-invalid');
            $('.feedback_agree_regulations2').html('<p>To pole jest wymagane</p>');
            errors = 1;
        } else {
            $('#formServiceAgreeRegulations2').removeClass('is-invalid');
            $('.feedback_agree_regulations2').empty();
        }
        var agreeVal1 = 0;
        var agreeVal2 = 0;

        if (agree1) {
            agreeVal1 = 1;
        }
        if (agree2) {
            agreeVal2 = 1;
        }

        var inputDealer = $("#inputDealerVisit").val();

        console.log(inputDealer);
        console.log(errors);
        if (errors == 0) {
             $('#formService .btn-form').attr("disabled", "true");    
            $.ajax({
                type: 'POST',
                url: '/wizyta-w-serwisie',
                data: {
                    _token: $('meta[name="csrf-token"]').attr('content'),
                    firstname: firstnameInputValue,
                    lastname: lastnameInputValue,
                    email: emailInputValue,
                    phone: phoneInputValue,
                    date: dataInputValue,
                    time: timeInputValue,
                    department: inputDealer,
                    vin: vinInputValue,
                    agree_regulations1: (agreeVal1 ? 'yes' : 'no'),
                    agree_regulations2: (agreeVal2 ? 'yes' : 'no'),
                    review: (reviewVal ? 'yes' : 'no'),
                    tires: (tiresVal ? 'yes' : 'no'),
                    service: (serviceVal ? 'yes' : 'no'),
                },
                success: function(result) {

                    console.log(result.success);
                    $('#formService .btn-form').removeAttr("disabled");
                    if (result.success) {


                        $("#formService").trigger("reset");
                        $('#formServiceFirstname').val('');
                        $('#formServiceLastname').val('');
                        $('#formServiceEmail').val('');
                        $('#formServicePhone').val('');
                        $('#formServiceDate').val('');
                        $('#formServiceVin').val('');
                        $('#formServiceTime').val('');
                        $('#formServiceReview').prop('checked', false);
                        $('#formServiceTires').prop('checked', false);
                        $('#formServiceService').prop('checked', false);
                        $('#formServiceAgreeRegulations1').prop('checked', false);
                        $('#formServiceAgreeRegulations2').prop('checked', false);

                        $('#visitServiceModal').modal('hide');

                        $('#formSuccess').modal('show')
                    } else {
                        alert('Zapis nie powiódł się. Spróbuj ponownie');
                    }
                }
            });
        }
    });

});
